import React from 'react'

export interface StatBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  value: React.ReactNode
  label: string
  trend?: string
  pulse?: boolean
}

const CSS = `
.wst-stat {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: var(--radius-xl, 16px);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 8px 24px -6px rgba(0, 0, 0, 0.35), inset 0 1px 1px 0 rgba(255, 255, 255, 0.08);
  transition: all 200ms ease;
  min-width: 140px;
}
.wst-stat:hover {
  transform: translateY(-2px);
  border-color: rgba(56, 191, 255, 0.3);
  box-shadow: 0 12px 28px -6px rgba(0, 0, 0, 0.45), 0 0 16px rgba(56, 191, 255, 0.12);
}

.wst-stat__value {
  color: #ffffff;
  font-family: var(--font-data, 'Space Grotesk', monospace);
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
  display: flex;
  align-items: center;
  gap: 8px;
}

.wst-stat__value--pulse {
  color: var(--c-pulse, #2AE6B6);
}

.wst-stat__trend {
  font-size: 13px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 9999px;
  background: rgba(42, 230, 182, 0.15);
  color: var(--c-pulse, #2AE6B6);
  border: 1px solid rgba(42, 230, 182, 0.3);
}

.wst-stat__label {
  color: rgba(255, 255, 255, 0.55);
  font-family: var(--font-body, system-ui);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
`

if (typeof document !== 'undefined' && !document.getElementById('wst-stat-css')) {
  const s = document.createElement('style')
  s.id = 'wst-stat-css'
  s.textContent = CSS
  document.head.appendChild(s)
}

export const StatBadge: React.FC<StatBadgeProps> = ({
  value,
  label,
  trend,
  pulse = false,
  className = '',
  style = {},
  ...rest
}) => {
  return (
    <div className={`wst-stat ${className}`} style={style} {...rest}>
      <span className={`wst-stat__value ${pulse ? 'wst-stat__value--pulse' : ''}`}>
        {value}
        {trend && <span className="wst-stat__trend">{trend}</span>}
      </span>
      <span className="wst-stat__label">{label}</span>
    </div>
  )
}
